<ng-container *transloco="let t; read:'feature.notification'">
    <div class="modal">
        <div class="modal__content">
            <div class="modal__content__header">
                <h2 class="modal__content__header__heading">{{ t("notifications") }}</h2>
                <ng-container *ngIf="notifications$ | async as notifications">
                    <div *ngIf="notifications.length > 0" class="modal__content__header__mark-as-read" (click)="markAllAsRead()">{{ t("markAsRead") }}</div>
                </ng-container>
            </div>
            <ng-container *ngIf="notifications$ | async as notifications">
                <ng-container *ngIf="notifications.length > 0">
                    <div class="modal__content__notification" *ngFor="let notification of notifications"
                         (click)="onNotificationClick(notification)"
                         [class.modal__content__notification--unread]="notification.status === PushNotificationStatus.Unread">
                        <div class="modal__content__notification__heading">{{ notification.title }}</div>
                        <div class="modal__content__notification__text">{{ notification.body }}</div>
                        <div class="modal__content__notification__text">{{ notification.receivedAt | haDate:'dateTimeStandard' }}</div>

                        <hr class="modal__content__notification__divider">
                    </div>
                </ng-container>

                <ng-container *ngIf="notifications.length === 0">
                    <div class="modal__content__notification__text">{{ t("noNotifications") }}</div>
                </ng-container>
            </ng-container>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("close") }}</button>
        </div>
    </div>
</ng-container>

